import { render } from "./TransactionHistoryText.vue?vue&type=template&id=84e7afa6&scoped=true"
const script = {}

import "./TransactionHistoryText.vue?vue&type=style&index=0&id=84e7afa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e7afa6"]])

export default __exports__